import Link from 'next/link';
import { CalculatorId, CalculatorType } from '../../lib/calculators/calculator-config';
import { calculatorsMap } from '../../components/calculators/calculators-map';
import { getCalculatorIcon } from '../../lib/calculators/calculator-icons';

export interface CalculatorCardProps {
  /**
   * The ID of the calculator or graph
   */
  calculatorId: CalculatorId;
}

export function CalculatorCard({ calculatorId }: CalculatorCardProps) {
  const calculator = calculatorsMap[calculatorId];
  
  if (!calculator?.description) {
    return null;
  }
  
  // Determine the correct calculator type based on the ID
  let calculatorType: string = CalculatorType.Table;
  
  if (calculatorId.startsWith('graphs/')) {
    calculatorType = CalculatorType.Graph;
  } else if (
    calculatorId === CalculatorId.NORMAL_DISTRIBUTION || 
    calculatorId === CalculatorId.BINOMIAL_DISTRIBUTION || 
    calculatorId === CalculatorId.CHI_SQUARE || 
    calculatorId === CalculatorId.ANOVA || 
    calculatorId === CalculatorId.KURTOSIS ||
    calculatorId === CalculatorId.MODE
  ) {
    calculatorType = 'distribution';
  } else if (calculatorId.startsWith('statistics/')) {
    calculatorType = 'statistics';
  }
  
  const { icon: Icon, color } = getCalculatorIcon(calculatorId, calculatorType);
  const { title: name, description } = calculator.description;
  const href = `/${calculatorId}`;
  
  return (
    <Link 
      href={href}
      className="group flex flex-col p-6 bg-card rounded-lg border border-border hover:shadow-md hover:border-primary transition-all no-underline"
    >
      <div className="flex items-center gap-4 mb-3">
        <div className={`p-2.5 rounded-md ${color}`}>
          <Icon className="h-5 w-5" />
        </div>
        <h3 className="font-medium text-lg group-hover:text-primary transition-colors">{name}</h3>
      </div>
      <p className="text-muted-foreground text-sm">{description}</p>
    </Link>
  );
} 